<script>
import { _request } from '@/helpers/_request'
import Parser from '@/helpers/_responseParser'

export default {
  name: 'PromoService',
  methods: {
    getPromoCollection () {
      return _request('GetPromoCollection').then(Parser.toXml.bind(null, 'GetPromocodesResponse'))
    },
    redeemPromoCode ({ Amount, Code, IssueNumber, ParentReferenceNumber = '', RemittanceGateway, ValidateOnly = true }) {
      return _request('RedeemPromoCode', {
        Amount,
        Code,
        IssueNumber,
        ParentReferenceNumber,
        RemittanceGateway,
        ValidateOnly
      }).then(Parser.toXml.bind(null, 'RedeemPromoCodeResponse'))
    },
    managePromoCode (OperationType, PromoCode, Issue) {
      return _request('ManagePromoCollection', { OperationType, PromoCode, Issue })
        .then(Parser.toXml.bind(null, 'ManagePromoCollectionResponse'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/PromoService.vue